export default __webpack_public_path__ + "static/media/kitchen3-before2-768w.f23200a7.png";